import clsx from 'clsx';
import React, { forwardRef } from 'react';

import { Table } from './Table';
import * as styles from './Table.css';
import { VirtuosoTableProps } from './VirtuosoTableContext';

export const VirtuosoTableHead = forwardRef<
  HTMLTableSectionElement,
  React.HTMLAttributes<HTMLTableSectionElement> & VirtuosoTableProps<any>
>(function VirtuosoTableHead({ children, context, className, ...rest }, ref) {
  return (
    <Table.Header
      ref={ref}
      className={clsx(styles.tableHeaderVirtuoso, className)}
      {...rest}
    >
      {children}
    </Table.Header>
  );
});
